export default "__VITE_ASSET__CMXT5hsJ__"